import { render, staticRenderFns } from "./NCalcTester.vue?vue&type=template&id=0c681682&"
import script from "./NCalcTester.vue?vue&type=script&lang=ts&"
export * from "./NCalcTester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports